// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper__Pr7XE","container":"Register_container__9OQLc","form_container":"Register_form_container__43Aos"};